module.exports = __webpack_public_path__ + "static/img/ent-69.b6897a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-69.jpg
// module id = tMZD
// module chunks = 52